import React from 'react';
import {Box, Button, Grid, Tooltip} from "@mui/material";
import {
	ArrowDropDownCircleOutlined as BackIcon,
	DeleteOutlineOutlined as DeleteIcon,
	LayersOutlined as DoubleIcon,
	ReplyOutlined as ResetIcon,
	CheckCircleOutlineOutlined as CheckIcon,
	SaveOutlined as SaveIcon,

} from '@mui/icons-material';
import {makeStyles} from "@mui/styles";

const ControlProductEdit = (props) => {
	const {
		duplicateProduct,
		onEditProduct,
		onDeleteProduct,
		isDisabledQueueTask,
		userRoles
	} = props;
	const classes = useStyles();

	const disabledTooltipButton = Boolean(isDisabledQueueTask) ? "Во время применения шаблонов будет недоступно сохранение - дождитесь завершения и лишь потом продолжите редактирование." : "";
	return (
		<Box sx={{
			bgcolor: '#ffffff',
			padding: '8px 9px',
			marginBottom: '12px',
			borderRadius: 1,
		}}>
			<Grid container justifyContent='space-between' spacing={1}>
				{Boolean(Array.prototype.contains(['admin'], userRoles)) && (
					<Grid item xs={1}>
						<Button
							variant="contained"
							size="medium"
							color="error"
							fullWidth
							startIcon={<DeleteIcon/>}
							onClick={onDeleteProduct}
						>
							Удалить
						</Button>
					</Grid>
				)}
				<Grid item xs>
					<Button
						className={classes.Button}
						variant="outlined"
						size="medium"
						startIcon={<DoubleIcon sx={{
							transform: 'rotate(-135deg)',
						}}/>}

						onClick={() => duplicateProduct(false)}
					>
						Дублировать
					</Button>
				</Grid>
				<Grid item xs={5}>
					<Tooltip title={disabledTooltipButton}>
						<div>
							<Button className={classes.Button} disabled={isDisabledQueueTask} variant="contained" size="medium"
							        startIcon={<CheckIcon/>} onClick={() => onEditProduct(false)}>
								Сохранить и продолжить
							</Button>
						</div>
					</Tooltip>
				</Grid>
				<Grid item xs>
					<Tooltip title={disabledTooltipButton}>
						<div>
							<Button className={classes.Button} disabled={isDisabledQueueTask} color="success" variant="contained" size="medium"
							        startIcon={<SaveIcon/>} onClick={() => onEditProduct(true)}>
								Сохранить
							</Button>
						</div>
					</Tooltip>
				</Grid>
			</Grid>
		</Box>
	);
};


const useStyles = makeStyles({
	Button: {
		width: "100%",
		'&:disabled': {
			background: 'rgba(0, 0, 0, 0.12)',
			color: 'rgba(0, 0, 0, 0.26)',
			'& svg': {
				fill: 'rgba(0, 0, 0, 0.12)'
			},
		}
	},
});

export default ControlProductEdit;
